import { GET_DECIDED_RECHARGE_REQUESTS_REQUEST, GET_DECIDED_RECHARGE_REQUESTS_SUCCESS, GET_DECIDED_RECHARGE_REQUESTS_FAILURE, GET_DECIDED_RECHARGE_REQUESTS_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getDecidedRechargeRequestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DECIDED_RECHARGE_REQUESTS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case GET_DECIDED_RECHARGE_REQUESTS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_DECIDED_RECHARGE_REQUESTS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case GET_DECIDED_RECHARGE_REQUESTS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getDecidedRechargeRequestsReducer;
